import { render, staticRenderFns } from "./PaneHeader.vue?vue&type=template&id=46c14b9f&"
import script from "./PaneHeader.vue?vue&type=script&lang=js&"
export * from "./PaneHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports